import { memo } from 'react'
import { locales } from '../../../../locales/en'
import type { IconProps } from '../../../Icons'
import Friended from '../../../Icons/Friended'
import { palette } from '../../../styles/colors'
import Container from '../Container'

interface FriendBadgeProps extends IconProps {
    shadow?: boolean
    size?: number
}

const FriendBadge = memo((props: FriendBadgeProps) => {
    const { shadow, size = 0.8, ...other } = props

    return (
        <Container title="Friended" shadow={shadow}>
            <Friended
                title={locales.settings.pinToTop.friends}
                color={palette.badgeFriend}
                size={size}
                {...other}
            />
        </Container>
    )
})

export default FriendBadge
export { FriendBadge }
